import moment from "moment";
import Utils from "./utils";

class DateUtils {
    formatDate (date) {
        if (Utils.isEmptyStr(date)) {
            return "";
        }

        date = new Date(date);

        var d = date.getDate();
        var m = date.getMonth() + 1;
        var y = date.getFullYear();
        return '' + y + '-' + (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
    };

    formatDateTime (date) {
        if (Utils.isEmptyStr(date)) {
            return "";
        };
        const date1 = new Date(date);
        return moment(date1, 'YYYY-MM-DD HH:mm').format('YYYY年MM月DD日 HH時mm分');
    };

    formatDateYYYYMMDD (date) {
        if (Utils.isEmptyStr(date)) {
            return "";
        };
        return moment(date, 'YYYY-MM-DD').format('YYYY年MM月DD日');
    };

    formatDateYYYYMM (date) {
        if (Utils.isEmptyStr(date)) {
            return "";
        };
        return moment(date, 'YYYY-MM').format('YYYY年MM月');
    };

    formatDateDD (date) {
        if (Utils.isEmptyStr(date)) {
            return "";
        };
        return moment(date, 'YYYY-MM-DD').format('DD');
    };

    formatDateDefault (date) {
        if (Utils.isEmptyStr(date)) {
            return "";
        };
        return moment(date).format('YYYY-MM-DD');
    };

    formatDateDot (date) {
        if (Utils.isEmptyStr(date)) {
            return "";
        };
        if (date.includes(".")) {
            return date;
        };
        return moment(date).format('YYYY.MM.DD');
    };

    formatDualDate (date1, date2) {
        if (Utils.isEmptyStr(date1) || Utils.isEmptyStr(date2)) {
            return "";
        };

        let strDate1 = moment(date1).format('YY/MM/DD');
        let strDate2 = moment(date2).format('YY/MM/DD');

        return strDate1 + " ~ " + strDate2;
    }

    formatYear (date) {
        if (Utils.isEmptyStr(date)) {
            return "";
        };
        return moment(date).format('YYYY');
    };

    formatMonthDay (date) {
        if (Utils.isEmptyStr(date)) {
            return "";
        };
        return moment(date).format('MM/DD');
    };

    getDay (date) {
        const weekStr = ["日", "月", "火", "水", "木", "金", "土"];
        if (date) {
            let dayNum = moment(date).day();
            return weekStr[dayNum];
        };
        return '';
    };

    getDayEng (date) {
        const weekStr = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        if (date) {
            let dayNum = moment(date).day();
            return weekStr[dayNum];
        };
        return '';
    };

    compareDate (start, end) {
        if (Utils.isEmptyStr(start) || Utils.isEmptyStr(end)) {
            return true;
        };

        let _start = start.getTime();
        let _end = end.getTime();
        return !(_start > _end);
        // if (_start > _end) {
        //     return false;
        // };
        // return true;
    };
};

const obj = new DateUtils();
export default obj;


// WEBPACK FOOTER //
// ./src/helpers/dateUtils.js